module.exports = __webpack_public_path__ + "media/videoToVideoDriver.98929e3d.mp4";